import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule for NgIf
import { LogoValuesType } from './logo.component.types';
import { IconSize } from '../icon';
// Define the allowed icon sizes

// Define the allowed color variants for the icon

@Component({
  selector: 'hyperkit-logo', // The tag name to use this component in templates
  standalone: true, // This component is standalone and does not require any other components
  imports: [CommonModule], // Add CommonModule to imports
  templateUrl: './logo.component.html', // HTML file for the component
  styleUrls: ['./logo.component.scss'], // SCSS file for the component's styles
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoComponent {
  // The ID of the SVG symbol in the sprite
  @Input() icon!: LogoValuesType;

  // The size of the icon, based on the predefined IconSize types
  @Input() size?: IconSize = 'small';

  // Accessibility role to describe the element as an image
  @Input() role?: string = 'img';

  // Accessibility label for screen readers
  @Input() ariaLabel?: string | null = null;

  // The fixed path to the SVG sprite file
  readonly spritePath: string = '../../../assets/tools.svg';

  /** Map product names to sprite IDs */
  private readonly iconMap: Record<string, string> = {
    'CrowdStrike': 'crowdstrike',
    'Elastic': 'elastic',
    'Yara': 'yara',
    'Snort': 'snort',
    'SentinelOne': 'sentinel-one',
    'Tanium': 'tanium',
    'Splunk': 'splunk',
    'TrendMicro': 'trend-micro',
    'Corelight': 'corelight',
    'CarbonBlack': 'carbonblack',
    'PaloAltoNetworks': 'palo-alto-networks',
    'PaloAltoNetworks Cortex': 'palo-alto-networks-cortex',
    'Microsoft Sentinel': 'microsoft-sentinel',
    'Microsoft Defender': 'microsoft-defender',
  };

    /** Resolve the final icon ID from the provided input */
    get computedIconId(): string {
      return this.iconMap[this.icon] ?? 'cyborg-eyes-outline-small';
    }
  

  /**
   * A getter to dynamically compute the classes for the icon.
   * Combines size and color-related classes based on the inputs provided.
   *
   * @returns {string[]} An array of classes to apply to the icon element.
   */
  get classes(): string[] {
    return [
      `icon-${this.size}`, // Class for the size of the icon
    ];
  }
}
